import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPhone } from '@fortawesome/pro-solid-svg-icons';
import {entryNumberSet} from "../component/options";

const abiFilersContact = [
  {
    name: 'contactName',
    label: 'Name',
    type: 'text',
    maxLength: 40,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: <FontAwesomeIcon icon={faUser} />,
  },
  {
    name: 'contactPhone',
    label: 'Phone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: <FontAwesomeIcon icon={faPhone} />,
  },
];

const abiFiler1 = [
  {
    name: 'filerPortCode',
    label: 'Port Code',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'filerOfficeCode',
    label: 'Office Code',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'filerCode',
    label: 'Filer Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
];

const abiFiler2 = [
  {
    name: 'entryNumberSet',
    label: 'Set',
    type: 'auto value',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryNumberRangeStart',
    label: 'Range Start',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryNumberRangeEnd',
    label: 'Range End',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'currentEntryNumber',
    label: 'Current',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
];

const optionsMap = {
  entryNumberSet: entryNumberSet,
};

export { abiFilersContact, abiFiler1, abiFiler2, optionsMap };